import { jsPDF } from 'jspdf'

export function addImageWithAspectRatio(
  doc: jsPDF,
  imgData: string,
  x: number,
  y: number,
  maxWidth: number,
  maxHeight: number,
  format: 'JPEG' | 'PNG' = 'JPEG',
) {
  return new Promise<void>((resolve) => {
    const img = new Image()
    img.src = imgData
    img.onload = function () {
      let { width, height } = img
      const scale = Math.min(maxWidth / width, maxHeight / height)
      width *= scale
      height *= scale
      doc.addImage(imgData, format, x, y, width, height)
      resolve()
    }
  })
}
